/* eslint-disable react/prop-types */
import { createRef, Component } from "react"
import _ from "underscore"
import KeyListener from "components/key_listener"
import FormForm from "./form_form"

const attendeesToVisibleIds = attendeeTypes => {
  return attendeeTypes.reduce((visibleToAttendeeTypeIds, at) => {
    visibleToAttendeeTypeIds[at.id] = true
    return visibleToAttendeeTypeIds
  }, {})
}

const addOnsToVisibleIds = addOns => {
  return addOns.reduce((visibleToAddOnIds, ao) => {
    visibleToAddOnIds[ao.id] = true
    return visibleToAddOnIds
  }, {})
}

class FormNew extends Component {
  constructor(props) {
    super(props)

    const { event: { attendeeTypes, addOns } = {} } = props

    this.state = {
      formType: props.formType || "pdf",
      name: props.name || "",
      attachment: null,
      hasRestrictionsOnAttendeeTypes: false,
      hasRestrictionsOnAddOns: false,
      visibleToAttendeeTypeIds: attendeesToVisibleIds(attendeeTypes),
      visibleToAddOnIds: addOnsToVisibleIds(addOns)
    }

    this.handleCancelClick = this.handleCancelClick.bind(this)
    this.handleSubmitClick = this.handleSubmitClick.bind(this)
    this.handleFormTypeChange = this.handleFormTypeChange.bind(this)
    this.handleNameChange = this.handleNameChange.bind(this)
    this.handleURLChange = this.handleURLChange.bind(this)
    this.handlePeopleFormSelect = this.handlePeopleFormSelect.bind(this)
    this.handlePDFUpload = this.handlePDFUpload.bind(this)
    this.handleAttendeeTypeLimitClick = this.handleAttendeeTypeLimitClick.bind(this)
    this.handleAddOnLimitClick = this.handleAddOnLimitClick.bind(this)
    this.handleVisibleToAttendeeTypesChange = this.handleVisibleToAttendeeTypesChange.bind(this)
    this.handleVisibleToAddOnsChange = this.handleVisibleToAddOnsChange.bind(this)

    this.keyListener = createRef()
  }

  handleCancelClick() {
    const { onCancel = () => {} } = this.props
    onCancel()
  }

  handleSubmitClick() {
    const { onSubmit = () => {}, event: { id } = {} } = this.props

    App.Modal.loadingModal("")

    const formData = this.buildFormData()

    fetch(`/signups/${id}/forms`, {
      method: "POST",
      headers: {
        "X-CSRF-Token": $.rails.csrfToken(),
        Accept: "application/json"
      },
      credentials: "include",
      body: formData
    })
      .then(resp => resp.json())
      .then(resp => {
        if (resp.errors) {
          alertModal({
            title: "An error occured",
            text: resp.errors,
            type: "error",
            confirmButtonText: "Ok",
            closeOnConfirm: true
          })
          Bugsnag.notifyException(resp, "FormPostError")
        } else {
          onSubmit(resp)
        }
      })
      .catch(resp => {
        Bugsnag.notifyException(resp, "FormPostError")
        alertModal({
          title: "An error occured",
          text: resp.errors,
          type: "error",
          confirmButtonText: "Ok",
          closeOnConfirm: true
        })
      })
      .finally(() => {
        App.Modal.hide()
      })
  }

  handleFormTypeChange(e) {
    const { event: { attendeeTypes, addOns } = {} } = this.props
    this.setState({
      formType: e.target.value,
      name: "",
      attachment: null,
      hasRestrictionsOnAttendeeTypes: false,
      visibleToAttendeeTypeIds: attendeesToVisibleIds(attendeeTypes),
      visibleToAddOnIds: addOnsToVisibleIds(addOns)
    })
  }

  handleNameChange(e) {
    this.setState({ name: e.target.value })
  }

  handleURLChange(e) {
    this.setState({
      remoteURL: e.target.value,
      remoteID: -99
    })
  }

  handlePeopleFormSelect(selectedForm) {
    this.setState({
      name: selectedForm ? selectedForm.name : null,
      remoteURL: selectedForm ? selectedForm.remoteURL : null,
      remoteID: selectedForm ? selectedForm.id : null
    })
  }

  handlePDFUpload(attachment) {
    this.setState({ attachment })
  }

  handleAttendeeTypeLimitClick() {
    const { event: { attendeeTypes } = {} } = this.props
    this.setState(prevState => ({
      hasRestrictionsOnAttendeeTypes: !prevState.hasRestrictionsOnAttendeeTypes,
      visibleToAttendeeTypeIds: attendeesToVisibleIds(attendeeTypes)
    }))
  }

  handleAddOnLimitClick() {
    const { event: { addOns } = {} } = this.props
    this.setState(prevState => ({
      hasRestrictionsOnAddOns: !prevState.hasRestrictionsOnAddOns,
      visibleToAddOnIds: addOnsToVisibleIds(addOns)
    }))
  }

  handleVisibleToAttendeeTypesChange(atId) {
    this.setState(prevState => ({
      visibleToAttendeeTypeIds: {
        ...prevState.visibleToAttendeeTypeIds,
        [atId]: !prevState.visibleToAttendeeTypeIds[atId]
      }
    }))
  }

  handleVisibleToAddOnsChange(aoId) {
    this.setState(prevState => ({
      visibleToAddOnIds: {
        ...prevState.visibleToAddOnIds,
        [aoId]: !prevState.visibleToAddOnIds[aoId]
      }
    }))
  }

  render() {
    const { event, peopleForms, style: propStyles, onCancel = () => {} } = this.props

    const {
      formType,
      name,
      attachment,
      hasRestrictionsOnAttendeeTypes,
      hasRestrictionsOnAddOns,
      visibleToAttendeeTypeIds,
      visibleToAddOnIds
    } = this.state

    const form = {
      active: true,
      attachment,
      formType,
      hasRestrictionsOnAddOns,
      hasRestrictionsOnAttendeeTypes,
      name,
      visibleToAddOnIds,
      visibleToAttendeeTypeIds
    }

    return (
      <div style={{ ...propStyles }}>
        <KeyListener
          ref={this.keyListener}
          register={{ Escape: onCancel }}
          render={() => (
            <FormForm
              event={event}
              form={form}
              peopleForms={peopleForms}
              onNameChange={this.handleNameChange}
              onFormTypeChange={this.handleFormTypeChange}
              onPeopleFormSelectChange={this.handlePeopleFormSelect}
              onURLChange={this.handleURLChange}
              onPDFUpload={this.handlePDFUpload}
              onAttendeeTypeLimitClick={this.handleAttendeeTypeLimitClick}
              visibleToAttendeeTypeIds={visibleToAttendeeTypeIds}
              visibleToAddOnIds={visibleToAddOnIds}
              onVisibleToAttendeeTypesChange={this.handleVisibleToAttendeeTypesChange}
              onAddOnLimitClick={this.handleAddOnLimitClick}
              onVisibleToAddOnsChange={this.handleVisibleToAddOnsChange}
              {...this.props}
              onSubmitClick={this.handleSubmitClick}
              onCancelClick={this.handleCancelClick}
              isValid={this.isValid()}
            />
          )}
        />
      </div>
    )
  }

  buildFormData() {
    const {
      name,
      attachment,
      remoteURL,
      remoteID,
      hasRestrictionsOnAddOns,
      hasRestrictionsOnAttendeeTypes,
      visibleToAttendeeTypeIds,
      visibleToAddOnIds
    } = this.state

    let formData = new FormData()

    attachment &&
      attachment.type === "application/pdf" &&
      formData.append(
        "form[attachment]",
        attachment,
        attachment.name || `registration-form-${new Date().getTime()}.pdf`
      )

    formData.append("form[name]", name)
    remoteURL && formData.append("form[remote_url]", remoteURL)
    remoteID && formData.append("form[remote_id]", remoteID)

    if (hasRestrictionsOnAttendeeTypes) {
      formData.append(
        "form[visible_to_attendee_type_ids]",
        Object.keys(visibleToAttendeeTypeIds)
          .filter(atid => {
            if (visibleToAttendeeTypeIds[atid]) {
              return Number(atid)
            }
          })
          .join()
      )
      formData.append("attendee_type_limit_forms", "1")
    }

    if (hasRestrictionsOnAddOns) {
      formData.append(
        "form[visible_to_add_on_ids]",
        Object.keys(visibleToAddOnIds)
          .filter(aoid => {
            if (visibleToAddOnIds[aoid]) {
              return aoid
            }
          })
          .join()
      )
      formData.append("add_on_limit_forms", "1")
    }

    return formData
  }

  isValid() {
    const { name, formType, attachment } = this.state

    const fileExists = formType === "pdf" ? !!attachment : true
    const nameExists =
      (typeof name === "string" || name instanceof String) && name.trim().length > 0

    return fileExists && nameExists
  }
}

export default FormNew
